/**
 * DeployModelConfirmModal — "Deploy Model" (Figma 9950:23972): the per-token
 * price note a SaaS user accepts before a model is deployed. The sentence comes
 * from ``POST billing/estimate`` (``model_deployment``) so the rate is stated
 * once, server-side; the local copy only covers a failed request.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Modal, SparkModalPortal, Text } from '@spark';

import { useCostEstimate } from '../hooks/useCostEstimate';
import '../billing.css';

export const DEPLOY_MODEL_MODAL_WIDTH = 480;
export const DEPLOY_MODEL_TITLE = 'Deploy Model';
export const DEPLOY_MODEL_CTA = 'Accept & Deploy';
export const DEPLOY_MODEL_FALLBACK_NOTE = 'Please note: Input tokens for Deployment costs $0.008 / MTok.';

const DEPLOYMENT_PARAMS = {};

export default function DeployModelConfirmModal({ open = false, onConfirm, onCancel }) {
    const { estimate } = useCostEstimate('model_deployment', DEPLOYMENT_PARAMS, { enabled: open, debounceMs: 0 });
    const note = estimate?.note || DEPLOY_MODEL_FALLBACK_NOTE;
    const cancel = () => onCancel?.();

    return (
        <SparkModalPortal open={open} onClose={cancel} width={DEPLOY_MODEL_MODAL_WIDTH} destroyOnClose>
            <Modal
                open
                className="billing-dialog deploy-model-modal"
                title={DEPLOY_MODEL_TITLE}
                showSubtitle={false}
                showOverlay={false}
                showScrollBar={false}
                fixedHeight={false}
                primaryLabel={DEPLOY_MODEL_CTA}
                tertiaryLabel="Cancel"
                onPrimaryClick={() => onConfirm?.()}
                onTertiaryClick={cancel}
                onCloseClick={cancel}
            >
                <div className="billing-dialog__body" data-testid="deploy-model-modal">
                    <Text as="p" variant="base-regular" color="primary" className="billing-dialog__copy">
                        {note}
                    </Text>
                </div>
            </Modal>
        </SparkModalPortal>
    );
}

DeployModelConfirmModal.propTypes = {
    open: PropTypes.bool,
    onConfirm: PropTypes.func,
    onCancel: PropTypes.func,
};
